__webpack_require__.p = "/activity-icons/referrals-hub/";